require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-ant-design.json") })
        }
      }, "path---package-bs-ant-design");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-ant-design!./.cache/json/package-bs-ant-design.json
// module id = 754
// module chunks = 231608221292675